import React from 'react';
import { Building, Heart, Banknote, MapPin } from 'lucide-react';
import { sectors } from '../data/mock';

const SectorsSection = () => {
  const sectorIcons = {
    'E-Governance': Building,
    'Healthcare': Heart,
    'Financial Services': Banknote,
    'Smart Cities': MapPin
  };

  return (
    <section id="sectors" className="dark-container py-20">
      <div className="dark-content-container">
        <div className="text-center mb-16">
          <h2 className="display-large mb-6">Industry Sectors</h2>
          <p className="body-large max-w-4xl mx-auto">
            Transforming key industries across the MENA region with innovative technology solutions
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {sectors.map((sector, index) => {
            const IconComponent = sectorIcons[sector.title];
            return (
              <div
                key={index}
                className="group p-8 rounded-lg dark-transition"
                style={{ 
                  background: 'rgba(255, 255, 255, 0.03)',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}
              >
                <div className="flex items-start space-x-6">
                  <div className="flex-shrink-0 w-16 h-16 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300" style={{ 
                    background: 'rgba(0, 255, 209, 0.15)' 
                  }}>
                    <IconComponent size={32} style={{ color: '#00FFD1' }} />
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="heading-1 mb-4">{sector.title}</h3>
                    <p className="body-medium mb-6">{sector.description}</p>
                    
                    <div>
                      <h4 className="heading-3 mb-4">Applications:</h4>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {sector.applications.map((application, appIndex) => (
                          <div 
                            key={appIndex}
                            className="flex items-center space-x-3 p-3 rounded" 
                            style={{ background: 'rgba(0, 255, 209, 0.05)' }}
                          >
                            <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#00FFD1' }}></div>
                            <span className="body-small">{application}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-16">
          <div className="p-8 rounded-lg" style={{ 
            background: 'rgba(0, 255, 209, 0.1)',
            border: '1px solid rgba(0, 255, 209, 0.3)'
          }}>
            <h3 className="heading-1 mb-4">Ready to Transform Your Industry?</h3>
            <p className="body-large mb-6">
              Let's discuss how our solutions can drive innovation in your sector
            </p>
            <button className="btn-primary">
              <span>Schedule Consultation</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectorsSection;